var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import {} from "../../actions.mjs";
import { elementInstance } from "../instance.mjs";
import { getCountries } from "../../atlas.mjs";
import { billingAddressElementId } from "./elements.mjs";
import { getBillingAddress } from "./utils.mjs";
// When unmounting the address element, we cannot retrieve its value.
// getValue() will not return any response. According to Stripe support,
// this is expected behavior as the element is unmounted. To work around
// this, we store the latest value in a variable.
let currentValue = undefined;
export const getCurrentBillingAddressValue = () => currentValue;
export const initializeStripeBillingAddressElements = (state, actions, elements) => {
    elementInstance({
        elementId: billingAddressElementId,
        idempotencyKey: state.id,
        onMount: (e) => __awaiter(void 0, void 0, void 0, function* () {
            const element = yield getOrCreateBillingAddressElement(state, elements);
            element.mount(e);
            element.on('change', ({ complete, value, isNewAddress }) => {
                currentValue = { complete, value, isNewAddress };
            });
            element.on('blur', () => {
                // See shippingAddressElements.ts for explanation on why we use a timeout.
                setTimeout(() => __awaiter(void 0, void 0, void 0, function* () {
                    const details = yield element.getValue();
                    const address = getBillingAddress(details);
                    yield actions.setBillingAddress(address);
                }), 500);
            });
            return () => {
                element.unmount();
                currentValue = undefined;
            };
        }),
    });
};
const getBillingAddressElement = (elements) => {
    return elements.getElement('address', { mode: 'billing' });
};
const getOrCreateBillingAddressElement = (state, elements) => __awaiter(void 0, void 0, void 0, function* () {
    const existingElement = getBillingAddressElement(elements);
    if (existingElement) {
        return existingElement;
    }
    const countryCodes = yield getCountryCodes(state);
    return createBillingAddressElement(state, elements, countryCodes);
});
const createBillingAddressElement = (state, elements, allowedCountries) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    return elements.create('address', {
        mode: 'billing',
        allowedCountries,
        display: {
            name: 'split',
        },
        defaultValues: state.customer.billingAddress && {
            firstName: state.customer.billingAddress.firstName,
            lastName: state.customer.billingAddress.lastName,
            address: {
                country: (_b = (_a = state.customer.billingAddress.countryCode) === null || _a === void 0 ? void 0 : _a.toUpperCase()) !== null && _b !== void 0 ? _b : '',
                line1: state.customer.billingAddress.address1,
                line2: state.customer.billingAddress.address2,
                city: state.customer.billingAddress.city,
                state: state.customer.billingAddress.stateOrProvince,
                postal_code: state.customer.billingAddress.postalCode,
            },
        },
    });
});
const getCountryCodes = (state) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield getCountries(state)();
    return response.allCountries.map(({ code }) => code);
});
//# sourceMappingURL=billingAddressElements.js.map